import React from "react";
import { DivStatusCommon } from "./StatusCommonStyled";

interface Props {
  label: string;
  status: string;
}
export const StatusCommon = ({ status, label }: Props) => {
  return (
    <div>
      <DivStatusCommon status={status}>
        <b>{label.toUpperCase()}</b>
      </DivStatusCommon>
    </div>
  );
};
